export enum STORE_CONST {
  GLOBAL_STORE_NAME = 'global',
  ANNOTATION_OVERRIDE = 'annotationOverrides',
}
